/**
 * Payment List block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is
 * lazy-loaded only when the block is present and motion is allowed.
 */

import './index.scss';

const paymentListBlocks = document.querySelectorAll('.payment-list');

if (paymentListBlocks.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		paymentListBlocks.forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.payment-list[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const heading = block.querySelector('.payment-list__heading');
					const items = block.querySelectorAll('.payment-list__item');

					const tl = gsap.timeline({
						defaults: {
							duration: 0.8,
							ease: 'power3.out',
						},
						scrollTrigger: {
							trigger: block,
							start: 'top 85%',
							once: true,
						},
					});

					if (heading) {
						tl.to(heading, { opacity: 1, y: 0 }, 0);
					}

					if (items.length) {
						tl.to(
							items,
							{
								opacity: 1,
								y: 0,
								stagger: 0.12,
							},
							heading ? 0.15 : 0
						);
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
